import { render } from "./qlc-number.vue?vue&type=template&id=612cfd1c&scoped=true"
import script from "./qlc-number.vue?vue&type=script&lang=js"
export * from "./qlc-number.vue?vue&type=script&lang=js"

import "./qlc-number.vue?vue&type=style&index=0&id=612cfd1c&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612cfd1c"]])

export default __exports__